export default __webpack_public_path__ + "static/media/logo_white.0630d558.png";